export default async function shortfetch(body, dontreturn) {
  console.log(JSON.stringify(body));

  let response = await fetch("/api/fetch_data.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-form-urlencoded",
    },
    body: JSON.stringify(body),
  });

  dontreturn ? (dontreturn = true) : (dontreturn = false);

  if (dontreturn) {
    return await response.ok;
  } else {
    return await response.json();
  }
}
